import styled from 'styled-components';

export const ContainerStyled = styled.span`
  flex: 1;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const ParentNameStyled = styled.span`
  color: var(--ds-text-subtlest, var(--ds-fb-text-subtlest));
`;
